import React from 'react'
import styled, { keyframes } from 'styled-components'
import media from 'styled-media-query'
import Img from 'gatsby-image'

export const Container = styled.div`
width: 100%;
margin: auto;
max-width: var(--width-container);
`;


export const Relative = styled.div`
position: relative;
display: flex;
height: 80vh;
align-items: center;
gap: 9rem;

${media.lessThan('large')`
height: 80vh;
`}
${media.lessThan('medium')`
height: auto;
margin-bottom: 6rem;}
padding: 0.6rem;
`}

`;

export const HeroContent = styled.div`
width: 60vh;
z-index: 0;
`

export const HeroImage = styled.img`
    width: 40%;
    position: absolute;
    right: 2rem;
    top: 15rem;
    border: 0;
  ${media.lessThan('large')`
  display: none;
  width: 35%;
`}
  ${media.lessThan('medium')`
  display: none;
`}
`

export const Title = styled.h1`
font-size:${props => (props.size || 'var(--h1)')};
font-weight: var(--bold);
margin-bottom: 1rem;
&:after{
  border-left: 1.5em solid var(--red);
  border-left-color: var(--red);
  display: block;
  content: "";
  height: 0.2rem;
  margin-top: 0.2em;
}
${media.lessThan('medium')`
font-size:var(--h1);
`}
`
export const H2 = styled.h2`
font-size:${props => (props.size || 'var(--h2)')};
font-weight: var(--bold);
margin-bottom: 1rem;
&:after{
  border-left: 1.5em solid var(--red);
  border-left-color: var(--red);
  display: block;
  content: "";
  height: 0.2rem;
  margin-top: 0.2em;
}
`


export const Row = styled.div`
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-align-content: flex-start;
  -ms-flex-line-pack: start;
  align-content: flex-start;
  -webkit-flex-wrap: ${props => (props.wrap ? 'wrap;' : 'none')};
  -ms-flex-wrap: ${props => (props.wrap ? 'wrap;' : 'none')};
  flex-wrap: ${props => (props.wrap ? 'wrap;' : 'none')};
  -webkit-box-pack: ${props => props.justify || 'center'};
  -webkit-justify-content: ${props => props.justify || 'center'};
  -ms-flex-pack: ${props => props.justify || 'center'};
  justify-content: ${props => props.justify || 'center'};
  align-items: ${props => props.align || 'center'};
  ${media.lessThan('medium')`
padding-top: 0rem;
`}
`

export const DividerForRow = styled.div`
  margin-top: ${props => props.Top || '10rem'};
  margin-bottom: ${props => props.Bottom || '10rem'};
`

export const LandingImage = styled.img`
    width: 50%;
    right: 0;
    top: 0;
    border: 0;
  ${media.lessThan('medium')`
display: none;
`}
`
export const Column = styled.div`
  margin: ${props => (props.auto ? 'auto' : null)};
  width: ${props => props.width || 'auto'};
  -webkit-align-self: center;
  -ms-flex-item-align: center;
  align-self: center;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  -webkit-align-content: center;
  -ms-flex-line-pack: center;
  align-content: center;
  text-align: ${props => props.text || 'left'};
  ${media.greaterThan('large')`
width: ${props => props.width || 'auto'};
`}
`

export const FeedbackColumn = styled.div`
  width: ${props => props.width || 'auto'};
  -webkit-align-self: center;
  -ms-flex-item-align: center;
  align-self: center;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  margin: 0.5rem;
  -webkit-align-content: center;
  -ms-flex-line-pack: center;
  align-content: center;
  text-align: -webkit-left;
  ${media.greaterThan('large')`
width: ${props => props.width || 'auto'};
`}
  ${media.lessThan('medium')`
text-align: -webkit-right;
width: auto;
`}
`
export const BorderedColumn = styled.div`
  width: ${props => props.width || 'auto'};
  -webkit-align-self: center;
  -ms-flex-item-align: center;
  align-self: center;
  padding-right: 1rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  -webkit-align-content: center;
  -ms-flex-line-pack: center;
  align-content: center;
  border-radius: 5px;
  filter: drop-shadow(0px 4px 4px rgba(0,0,0,0.25));
  background: white;
  padding: 2rem;
  ${media.lessThan('medium')`
width: -webkit-fill-available;
padding: 1rem;
`}
  ${media.greaterThan('large')`
width: ${props => props.width || '-webkit-fill-available'};
`}
`
export const Header = styled.h1`
  font-style: normal;
  font-size: 4rem;
  font-weight: var(--bold);
  margin-bottom: 2rem;
  line-height: 4.4rem;
`

export const Header2 = styled.h2`
  font-weight: 600;
  font-style: normal;
  font-size: 32px;
`
export const CountingHeader = styled.h2`
  font-weight: 400;
  font-style: normal;
  font-size: 26px;
  ${media.lessThan('medium')`
text-align: center;
line-height: 5rem;
`}
`

export const HeaderBold = styled.h1`
  font-weight: 700;
  font-style: normal;
  font-size: 32px;
`
export const SubHeader = styled.h3`
  font-weight: 700;
  margin-bottom: -1rem;
  font-size: ${props => props.Size || '14px'};
  color: ${props => props.Color || 'black'};
`
export const FormTitle = styled.text`
  font-weight: 700;
  font-size: ${props => props.Size || '14px'};
  color: ${props => props.Color || 'black'};
`

export const Text = styled.p`
  font-size:  var(--textBase);
  color: var(--secondary);
`
export const Badge = styled.span`
 color: var(--red);
  font-weight: 100;
  font-size: var(--textInfo);
`;

export const HorizontalIconWrapper = styled.div`
  width: auto;
  display: flex;
  margin-top: 4rem;
  align-items: center;
  border-radius: 1rem;
  border: 1px solid;
  transition: all 0.3s ease;
  h1 {
    font-size: 16px;
  }
  &:hover {
    cursor: pointer;
    background: var(--redGR);
    color: white;
    transition: all 0.3s ease;
    transform: translate3d(0px, -4px, 0px);
  }
`
export const HorizontalTextWrapper = styled.div`
display:flex;
flex-wrap: wrap;
text-align: left;
justify-content: unsafe;
margin-left: 1rem;
`

export const IconCard = styled.div`
  width: 5rem;
  height: 5rem;
  padding: 13px;
  border-radius: 10px;
  transition: all 0.1s ease-in;
  svg g {
    fill: var(--red);
  }
`
export const SVG = styled.img`
  width: ${props => props.Size || 'auto'};
  filter: ${props => (props.gray ? 'grayscale(1)' : 'none')};
  margin-right: ${props => props.right || '0'};
  margin: auto;
`
export const CardImages = styled.img`
    filter: grayscale(1);
  &:hover {
    cursor: pointer;
    filter: grayscale(0);
    transition: filter 0.1s ease-in;
  }
`
export const SVGIcon = styled.div`
  width: 4rem;
  height: 4rem;
  border: 1px solid #6d5e5e94;
  border-radius: 16px;
  -webkit-transition: all 0.1s ease-in;
  transition: all 0.1s ease-in;
`
export const RedStick = styled.div`
  height: 10px;
  background: #d00045;
  position: relative;
  top: 10rem;
  z-index: -1;
  width: 100%;
  margin: auto;
`
export const AniStick = styled.div`
  height: 15px;
  background: ${props => props.C || 'var(--red)'};
  width: ${props => props.W || '12rem'};
  top: ${props => props.T || '12rem'};
  margin-top: 1rem;
  top: 10rem;
  z-index: -1;
  transition: all 0.6s ease-in;
  @media (max-width: 768px) {
    display: none;
  }
`
export const ButtonGroup = styled.div`
align-items: center;
flex-wrap: wrap;
z-index:1200;
`

export const Button = styled.button`
  background: ${props => props.Color || 'var(--secondary)'};
  padding: 0.8rem 1rem;
  margin: 0 1.125em 1.125em 0;
  width: auto;
  border-radius: 0.2rem;
  color: white;
  outline: none;
  border: none;
  display:block;
  margin-top: 1rem;
  cursor: pointer;
  display: inline-block;
  font-weight: 100;
  line-height: 1.25;
  padding: .625em 1.5em;
  text-align: center;
  text-decoration: none;
  font-size: var(--textBase);
  &:hover {
    background: var(--secondaryHover); 
  }
  &:active,
  &:focus {
    background: var(--secondaryHover); 
  }
`
export const ButtonOutline = styled.button`
  border: 1px solid var(--secondary);
  color:  var(--secondary);
  background: none;
  padding: 0.8rem 1rem;
  margin: 0 1.125em 1.125em 0;
  width: auto;
  border-radius: 0.2rem;
  outline: none;
  display: block;
  margin-top: 1rem;
  cursor: pointer;
  display: inline-block;
  font-weight: 100;
  line-height: 1.25;
  padding: .625em 1.5em;
  text-align: center;
  text-decoration: none;
  font-size: var(--textBase);
  &:hover {
    border: 1px solid var(--secondaryHover);
  }
  &:active,
  &:focus {
    border: 1px solid var(--secondaryHover);
  }
`


export const RetmonCTAButton = styled.button`
  background: ${props => props.Color || 'var(--secondary)'};
  padding: 0.8rem 1rem;
  width: auto;
  border-radius: 0.2rem;
  color: white;
  outline: none;
  border: none;
  display:block;
  margin-top: 1rem;
  cursor: pointer;
  float: ${props => (props.right ? 'right' : 'unset')};
  font-size: var(--textBase);
  
  &:hover {
    background: var(--secondaryHover); 
  }
  &:active,
  &:focus {
    background: var(--secondaryHover); 
  }
`
export const Span = styled.span`
  color: ${props => props.Color || 'var(--red)'};
`

export const FlexCard = styled.div`
  margin: 2rem;
`
export const FlexColumn = styled.div`
  width: ${props => props.width || 'auto'};
  -webkit-align-self: center;
  -ms-flex-item-align: center;
  align-self: center;
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  margin: 0.5rem;
  -webkit-align-content: center;
  -ms-flex-line-pack: center;
  align-content: center;
`
export const FlexRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  ${media.lessThan('medium')`
flex-wrap: wrap;
`}
`

export const FlexWrapRow = styled.div`
  display: flex;
  ${media.lessThan('medium')`
flex-wrap: wrap;
`}
`
export const BorderedItem = styled.div`
  width: 50%;
  filter: drop-shadow(0px 4px 4px rgba(0,0,0,0.25));
  border-radius: 5px;
  margin: 1rem;
  background: white;
  padding: 2rem;
  ${media.lessThan('medium')`
 width: 100%;
`}
  h1 {
    margin-bottom: 1rem;
  }
`

export const SocialWrapper = styled.div`
margin-top: 1rem;
  svg {
    width: 1.7rem;
    height: 1.7rem;
    margin-top:5px;
    margin-right: 2rem;
    transition: fill 0.1s ease-in;
  }
  svg:hover {
    fill: var(--red);
    cursor: pointer;
    transition: fill 0.1s ease-in;
  }
`

export const SolutionIcons = styled.div`
  margin-top: 2rem;
  margin-bottom: 2rem;
  display: flex;
  justify-content: space-between;
  gap: 3rem;
  img {
    width: 16rem;
  }
  ${media.lessThan('medium')`
display: grid;
margin: auto;
justify-content: center;
img{
  width:13rem!important;
}
`}
`

export const SolutionTitle = styled.h3`
  font-size: ${props => props.Size || 'var(--textInfo)'};
  margin-top: 0.5rem;
  color: ${props => props.Color || 'var(--info)'};
`


export const FlexCardImages = styled.div`
  margin-top: 2rem;
  margin-bottom: 2rem;
  display: flex;
  justify-content: space-between;
  img {
    width: 16rem;
  }
  ${media.lessThan('medium')`
display: grid;
justify-content: center;
justify-content: start;
img{
  width:13rem!important;
}
`}
`
export const FeedbackWrapper = styled.div`
  ${media.lessThan('medium')`
display: none;
`}
`
export const SvgWizardIcon = props => (
  <svg viewBox="0 0 47.18 47.18" {...props}>
    <g data-name="Layer 2">
      <SvgFill fill="#d40046" data-name="Layer 1">
        <path d="M20.72 20.25l6.22 6.23L33.45 20l-6.24-6.23zM40.23 5l-5.55 5.53 1.76 2.08 5.72-5.7zM11.61 6.88l5.62 5.6 1.88-1.73-5.67-5.7zm23 23l5.56 5.56 1.9-1.84-5.6-5.6zm-20-11h-8v2.86h8zM28.26 40.6v-8h-2.84v8zM0 41.94a7.48 7.48 0 012.3-3.52q7.56-7.49 15.05-15l.75-.71 6.41 6.41c-.13.14-.37.41-.63.67C18.82 34.82 13.74 39.87 8.7 45a7.34 7.34 0 01-3.46 2.23H3.77A5.19 5.19 0 010 43.41zM28.31 0v8.07h-2.93V0zM47.18 21.81h-8.06v-2.94h8.06z" />
        <path d="M20.72 20.25l6.49-6.51L33.45 20l-6.51 6.51zM40.23 5l1.93 1.91-5.72 5.7-1.76-2.08zM11.61 6.88l1.83-1.83 5.67 5.7-1.88 1.73zM34.6 29.92L36.47 28l5.59 5.62-1.9 1.84zM14.61 18.91v2.86h-8v-2.86zM28.26 40.6h-2.84v-8h2.84z" />
      </SvgFill>
    </g>
  </svg>
)

export const WhatsappIcon = props => (
  <svg viewBox="0 0 40 39" width={50} height={50} {...props}>
    <style>{'.icon_logo_white{fill:#fff}'}</style>
    <path
      d="M10.7 32.8l.6.3c2.5 1.5 5.3 2.2 8.1 2.2 8.8 0 16-7.2 16-16 0-4.2-1.7-8.3-4.7-11.3s-7-4.7-11.3-4.7c-8.8 0-16 7.2-15.9 16.1 0 3 .9 5.9 2.4 8.4l.4.6-1.6 5.9 6-1.5z"
      fill="#00e676"
    />
    <path
      className="icon_logo_white"
      d="M32.4 6.4C29 2.9 24.3 1 19.5 1 9.3 1 1.1 9.3 1.2 19.4c0 3.2.9 6.3 2.4 9.1L1 38l9.7-2.5c2.7 1.5 5.7 2.2 8.7 2.2 10.1 0 18.3-8.3 18.3-18.4 0-4.9-1.9-9.5-5.3-12.9zM19.5 34.6c-2.7 0-5.4-.7-7.7-2.1l-.6-.3-5.8 1.5L6.9 28l-.4-.6c-4.4-7.1-2.3-16.5 4.9-20.9s16.5-2.3 20.9 4.9 2.3 16.5-4.9 20.9c-2.3 1.5-5.1 2.3-7.9 2.3zm8.8-11.1l-1.1-.5s-1.6-.7-2.6-1.2c-.1 0-.2-.1-.3-.1-.3 0-.5.1-.7.2 0 0-.1.1-1.5 1.7-.1.2-.3.3-.5.3h-.1c-.1 0-.3-.1-.4-.2l-.5-.2c-1.1-.5-2.1-1.1-2.9-1.9-.2-.2-.5-.4-.7-.6-.7-.7-1.4-1.5-1.9-2.4l-.1-.2c-.1-.1-.1-.2-.2-.4 0-.2 0-.4.1-.5 0 0 .4-.5.7-.8.2-.2.3-.5.5-.7.2-.3.3-.7.2-1-.1-.5-1.3-3.2-1.6-3.8-.2-.3-.4-.4-.7-.5h-1.1c-.2 0-.4.1-.6.1l-.1.1c-.2.1-.4.3-.6.4-.2.2-.3.4-.5.6-.7.9-1.1 2-1.1 3.1 0 .8.2 1.6.5 2.3l.1.3c.9 1.9 2.1 3.6 3.7 5.1l.4.4c.3.3.6.5.8.8 2.1 1.8 4.5 3.1 7.2 3.8.3.1.7.1 1 .2h1c.5 0 1.1-.2 1.5-.4.3-.2.5-.2.7-.4l.2-.2c.2-.2.4-.3.6-.5.2-.2.4-.4.5-.6.2-.4.3-.9.4-1.4v-.7s-.1-.1-.3-.2zM56.2 23.5h-.1l-2.7-10h-2.1l-2.6 10h-.1l-2.3-10h-2.5l3.6 13.4h2.3l2.7-9.5h.1l2.7 9.5h2.2l3.5-13.3h-2.4l-2.3 9.9zm12.2-7c-.7 0-1.4.2-2 .5-.5.3-1 .8-1.2 1.3H65v-5.5h-2.3v14.1H65V21c0-.7.2-1.3.7-1.8.5-.5 1.1-.7 1.8-.7.6 0 1.2.2 1.6.6.4.5.6 1.1.5 1.7v6H72v-6.5c.1-1-.3-2-.9-2.8-.7-.7-1.7-1-2.7-1zm10 0c-1.1 0-2.1.2-3 .8-.7.5-1.2 1.3-1.3 2.1h2.2c.1-.3.4-.6.7-.8.4-.2.9-.3 1.3-.3.5 0 1 .1 1.4.4.3.3.5.7.5 1.2v.9l-2.6.2c-1 0-2 .3-2.9.9-.7.5-1 1.3-1 2.2 0 .8.3 1.6.9 2.2.7.6 1.5.9 2.4.8.6 0 1.2-.1 1.8-.4.5-.3.9-.7 1.2-1.1h.2V27h2.2v-7c.1-1-.3-1.9-1.1-2.5-.8-.8-1.9-1.1-2.9-1zm1.8 6.7c0 .6-.2 1.1-.7 1.5-.5.4-1.1.6-1.7.6-.5 0-.9-.1-1.3-.4-.3-.2-.5-.6-.5-1 0-.8.6-1.3 1.9-1.4l2.3-.1v.8zm7.6-8.9h-2.3v2.5h-1.7v1.8h1.7v5.5c-.1.8.2 1.6.8 2.1.7.5 1.6.7 2.5.6.4 0 .8 0 1.2-.1V25h-.8c-.4 0-.8-.1-1.1-.3-.2-.3-.4-.7-.3-1.1v-5H90v-1.8h-2.2v-2.5zm9.2 6.8l-1.8-.4c-.4-.1-.8-.2-1.1-.5-.2-.2-.4-.4-.4-.7 0-.4.2-.7.5-.9.4-.2.9-.4 1.3-.3.5 0 .9.1 1.3.3.3.2.5.5.6.9h2.2c0-.9-.5-1.7-1.2-2.2-.9-.5-1.9-.8-2.9-.8s-2.1.3-2.9.9c-.7.5-1.1 1.4-1.1 2.2 0 .7.2 1.3.7 1.8.6.5 1.4.9 2.2 1l1.8.4c.9.2 1.4.6 1.4 1.2 0 .4-.2.7-.5.9-.4.2-.9.4-1.4.3-.5 0-1-.1-1.4-.3-.3-.2-.6-.5-.7-.9h-2.3c0 .9.5 1.7 1.3 2.2.9.6 2 .8 3 .8 1.1 0 2.2-.3 3.1-.9.8-.5 1.2-1.4 1.2-2.4 0-.7-.2-1.3-.7-1.8-.8-.4-1.5-.7-2.2-.8zm8.4-7.6l-4.8 13.4h2.4l1.2-3.4h5l1.1 3.4h2.6l-4.8-13.4h-2.7zm-.6 8.1l1.8-5.5h.2l1.8 5.5h-3.8zm15.2-5c-.7 0-1.3.2-1.9.5-.5.3-1 .8-1.3 1.4h-.2v-1.7h-2.2v13.4h2.3v-4.8h.2c.3.5.7 1 1.2 1.3.6.3 1.2.5 1.9.4 1.2 0 2.3-.5 3-1.4.8-1.1 1.2-2.5 1.1-3.8.1-1.4-.3-2.7-1.1-3.8-.7-1.1-1.9-1.6-3-1.5zm1.1 7.6c-.8 1-2.4 1.2-3.4.3l-.3-.3c-.5-.7-.7-1.5-.7-2.4 0-.9.2-1.7.7-2.4.9-1 2.4-1.2 3.4-.3l.3.3c.5.7.7 1.6.7 2.4 0 .9-.2 1.7-.7 2.4zm13.5-6.2c-.7-.9-1.9-1.5-3.1-1.4-.7 0-1.3.2-1.9.5-.5.3-1 .8-1.3 1.4h-.2v-1.7H126v13.4h2.3v-4.8h.2c.2.5.6 1 1.2 1.3.6.3 1.2.5 1.9.4 1.2.1 2.3-.5 3.1-1.4.8-1.1 1.2-2.5 1.1-3.8 0-1.5-.4-2.8-1.2-3.9zm-1.9 6.2c-.8 1-2.4 1.2-3.4.3l-.3-.3c-.5-.7-.7-1.5-.7-2.4 0-.9.2-1.7.7-2.4.9-1 2.4-1.2 3.4-.3l.3.3c.5.7.7 1.6.7 2.4 0 .9-.3 1.7-.7 2.4z"
    />
  </svg>
)

export const RightArrow = props => (
  <svg
    aria-hidden="true"
    width="1em"
    height="1em"
    style={{
      msTransform: 'rotate(360deg)',
      WebkitTransform: 'rotate(360deg)',
    }}
    viewBox="0 0 24 24"
    transform="rotate(360)"
    {...props}
  >
    <SvgFill fill="#d40046" data-name="Layer 1">
      <path d="M12.012.752C5.799.752.762 5.789.762 12.002s5.037 11.25 11.25 11.25 11.25-5.037 11.25-11.25S18.225.752 12.012.752zm6.894 18.144a9.684 9.684 0 01-6.859 2.835c-5.365 0-9.715-4.349-9.715-9.715s4.349-9.715 9.715-9.715c5.365 0 9.715 4.349 9.715 9.715a9.688 9.688 0 01-.79 3.843l.024-.063a9.768 9.768 0 01-2.09 3.099z" />
      <path d="M11.233 7.734l3.518 3.518H6.006v1.5h8.745l-3.518 3.518 1.061 1.061 5.329-5.329-5.329-5.329-1.061 1.061z" />
    </SvgFill>
  </svg>
)

export const SvgFill = styled.g`
  ${HorizontalIconWrapper}:hover & {
    fill: white;
  }
`
export const DocumentCol = styled.div`
  z-index: 1200;
  text-align: -webkit-center;
  width: 6rem;
  position: fixed;
  bottom: 2rem;
  left: 5rem;
  margin-bottom: 1rem;
  &:hover {
    cursor: pointer;
    transform: scale3d(1.04, 1.04, 1.04);
    transition: transform 0.2s ease-in;
  }
  ${media.lessThan('medium')`
display:none;
`}
`
export const WhatsappCol = styled.div`
  text-align: -webkit-center;
  width: 6rem;
  position: fixed;
  bottom: 19rem;
  left: 5rem;
  margin-bottom: 1rem;
  &:hover {
    cursor: pointer;
    transform: scale3d(1.04, 1.04, 1.04);
    transition: transform 0.2s ease-in;
  }
  ${media.lessThan('medium')`
display:none;
`}
  a svg {
    font-size: 4rem;
    color: var(--bg-dark);
  }
`

export const VideoIntro = styled.video`
  width: 100%;
  border-radius: 1rem;
  outline: none;
`

export const BlogGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  margin-top: 1rem;
  gap: 2rem;
  ${media.lessThan('medium')`
  grid-template-columns: none;
  `}
`
export const BlogCol = styled.a`
  &:hover {
    cursor: pointer;
  }
`
export const BlogHeader = styled.h3`
  font-size: var(--textBase);
  font-weight: bold;
  margin: 0;
`
export const BlogDesc = styled.p`
  font-size: var(--textBase);
  margin-bottom: 1rem;
`
export const BlogDate = styled.time`
  font-size: var(--textInfo);
  color: var(--info)
`
export const BlogImg = styled.img`
  border-radius: 0.4rem;
  margin-bottom: 1rem;
`

export const FeedbackIcon = styled.img`
width: 12rem
`;